import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { recordingEntitties } from '../../constant'
import OptionLayout from '../OptionLayout'
import './feature-detail-content.scss'

const FeatureDetail = () => {
	const { id } = useParams();
	const feature = recordingEntitties.find((item) => item.key === id);
	const [entities, setEntities] = useState(feature?.entities || []);
	const { t } = useTranslation();

	useEffect(() => {
		const nextFeature = recordingEntitties.find((item) => item.key === id);
		setEntities(nextFeature?.entities || []);
	}, [id]);

	if (!feature) {
		return (
			<div className="features-page">
				<div className="features-page__container">
					<p>{t('no_data_found')}</p>
					<Link to="/features" className="features-page__back-link">
						<ArrowLeft size={16} aria-hidden="true" />
						{t('features')}
					</Link>
				</div>
			</div>
		);
	}

	return (
		<div className="features-page features-page--detail">
			<div className="features-page__container">
				<Link to="/features" className="features-page__back-link">
					<ArrowLeft size={16} aria-hidden="true" />
					{t('features')}
				</Link>

				<header className="features-page__header features-page__header--left">
					<h1 className="features-page__title">{t(feature.name)}</h1>
					<p className="features-page__intro features-page__intro--left">{t(feature.description)}</p>
				</header>

				<section className="features-page__panel">
					<h2 className="features-page__panel-title">{t(feature.overview.name)}</h2>
					<p className="features-page__panel-text">{t(feature.overview.description)}</p>
					<div className="features-page__options">
						{entities.map((value) => (
							<OptionLayout
								key={`${id}-${value.key}`}
								title={t(value.key)}
								record={value}
								category={feature.key}
							/>
						))}
					</div>
				</section>

				{feature.entityDescription?.map((desc) => (
					<section key={desc.heading} className="features-page__panel">
						<h2 className="features-page__panel-title">{t(desc.heading)}</h2>
						<p className="features-page__panel-text">{t(desc.description)}</p>
					</section>
				))}
			</div>
		</div>
	);
}

export default FeatureDetail;
